import withLoader from "../../layouts/WithLoader"
import { useState } from "react";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import { TextField } from "@material-ui/core";
import { Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import SalesService from "../../../services/SellingService";
import UploadAndDownloadService from "../../../services/uploadAndDownloadFile";
import BCService from "../../../services/BC";
import ListBanquesToPayement from "../../../models/ListBanquesToPayement";

const PayementAvanceBillVirementFN =({startLoading,stopLoading})=>{

    const [openErrorAlert, setOpenErrorAlert] = useState(false);
    const [errorAlertText, setErrorAlertText] = useState();
    const [datePayement, setDatePayement] = useState("");
    const [codeVirement, setCodeVirement] = useState("");
    const [fileName, setFileName] = useState("");
    const [openInfoAlert, setOpenInfoAlert] = useState(false);

    const [infoAlertText, setInfoAlertText] = useState();
    const [file, setFile] = useState([]);

    const [amount, setAmount] = useState();

    const changeDatePayement = (event) => {
        setDatePayement(event.target.value.concat(":59"));
    };
    const changeAmount = (event) => {
        setAmount(event.target.value);
    };

    const handleInfoClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setOpenInfoAlert(false);
    };

    const changeCodeVirement = (event) => {
        setCodeVirement(event.target.value);
    };

    const onUploadFileHandler = (e) => {
        if (e.target.files[0].size > 2097152) {
            setOpenInfoAlert(true);
            setInfoAlertText("la taille du fichier ne doit pas dépasser 2 Mo");
        } else {
            setFileName(e.target.files[0].name);

            setFile(e.target.files[0]);
        }
    };
    const handleEroorClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setOpenErrorAlert(false);
    };
    const payerBill = (e) => {
        const url = window.location.pathname.split("/")[1];
        if (url === "payerBill") {
            if (codeVirement === "") {
                setOpenErrorAlert(true);
                setErrorAlertText("Erreur : le code du chèque est vide ");
                // toast.error("Erreur : le champ  code chéque est vide");
            } else if (datePayement === "") {
                setOpenErrorAlert(true);
                setErrorAlertText("Erreur : la date d'écheance est vide ");
            } else if (amount === "") {
                setOpenErrorAlert(true);
                setErrorAlertText("Erreur : le montant est vide ");
            }else if (localStorage.getItem("banqueAccount") == null) {
                setOpenErrorAlert(true);
                setErrorAlertText("Erreur : Merci de choisir un compte bancaire ");
            } else {

                let payFactureOrAvance = {
                    idUser: getCurrentUserId(),
                    isFactureOrBDC: 1,
                    idDocument: parseInt(localStorage.getItem("idBill")),
                    isAvanceOrTotalPayement: 0,
                    typePayement: 3,
                    echanceDate: datePayement,
                    ammountPayed: amount,
                    urlFile: "any",
                    banqueAccountId: parseInt(localStorage.getItem("banqueAccount")),
                    numVirement: codeVirement,
                };
                startLoading();
                if (file.length !== 0) {
                    const uploadData = new FormData();
                    uploadData.append("picture", file);

                    UploadAndDownloadService.uploadFile(
                        "/retail/uploadFile/uploadFile/Payement",
                        uploadData
                    )
                        .then((response) => {
                            if (response.data["success"]) {
                                payFactureOrAvance.urlFile = response.data.success;
                                BCService.payFactureOrBDC(payFactureOrAvance)

                                    .then((response) => {
                                        console.log(response);
                                        if (response.data["error"]) {
                                            //   toast.error("Error : il ya un probléme");
                                        } else {
                                            setTimeout(() => {
                                                window.location.reload(true);
                                            }, 2000);
                                        }
                                    })
                                    .catch((error) => {
                                        // toast.error("Error : il ya un probléme");

                                        // this.refreshPage();
                                    });
                            } else {
                                // toast.error("Erreur : il ya un probléme au niveau de serveur");
                            }
                        })
                        .catch(() => {
                            //   toast.error("Erreur : il ya un probléme de connection");
                        }).finally(() => {
                            stopLoading();
                        });

                } else {
                    startLoading();

                    BCService.payFactureOrBDC(payFactureOrAvance)
                        .then((response) => {
                            if (response.data["error"]) {
                                // toast.error("Error : il ya un probléme");
                            } else {
                                setTimeout(() => {
                                    window.location.reload(true);
                                }, 2000);
                            }
                        })
                        .catch((error) => {
                            //   toast.error("Error : il ya un probléme");

                            //   this.refreshPage();
                        }).finally(() => {
                            stopLoading();
                        });
                }
            }
        } else {
            if (codeVirement === "") {
                setOpenErrorAlert(true);
                setErrorAlertText("Erreur : le code du chèque est vide ");
                // toast.error("Erreur : le champ  code chéque est vide");
            } else if (datePayement === "") {
                setOpenErrorAlert(true);
                setErrorAlertText("Erreur : la date d'écheance est vide ");
            } else if (amount === "") {
                setOpenErrorAlert(true);
                setErrorAlertText("Erreur : le montant est vide ");
            }  else if (localStorage.getItem("banqueAccount") == null) {
                setOpenErrorAlert(true);
                setErrorAlertText("Erreur : Merci de choisir un compte bancaire ");
            } else {
                let payementModel = {
                    idUser: getCurrentUserId(),
                    isFactureOrBDC: 1,
                    idDocument: parseInt(localStorage.getItem("idBill")),
                    isAvanceOrTotalPayement: 0,
                    typePayement: 3,
                    echanceDate: datePayement,
                    ammountPayed: amount,
                    urlFile: "any",
                    banqueAccountId: parseInt(localStorage.getItem("banqueAccount")),
                    numVirement: codeVirement,
                };
                startLoading();
                if (file.length !== 0) {
                    const uploadData = new FormData();
                    uploadData.append("picture", file);

                    UploadAndDownloadService.uploadFile(
                        "/sales/uploadFileSelling/uploadFile/Payement",
                        uploadData
                    )
                        .then((response) => {
                            if (response.data["success"]) {
                                payementModel.urlFile = response.data.success;
                                SalesService.payFactureOrBDC(payementModel)

                                    .then((response) => {
                                        console.log(response);
                                        if (response.data["error"]) {
                                            //   toast.error("Error : il ya un probléme");
                                        } else {
                                            setTimeout(() => {
                                                window.location.reload(true);
                                            }, 2000);
                                        }
                                    })
                                    .catch((error) => {
                                        console.log("error", error);

                                    })

                            } else {


                            }
                        })
                        .catch(() => {
                            //   toast.error("Erreur : il ya un probléme de connection");
                        })
                        .finally(() => {
                            stopLoading();
                        });
                } else {
                    startLoading();
                    SalesService.payFactureOrBDC(payementModel)

                        .then((response) => {
                            console.log(response);
                            if (response.data["error"]) {
                                //   toast.error("Error : il ya un probléme");
                            } else {
                                setTimeout(() => {
                                    window.location.reload(true);
                                }, 2000);
                            }
                        })
                        .catch((error) => {
                            console.log("error", error);
                            // toast.error("Error : il ya un probléme");

                            //   this.refreshPage();
                        })
                        .finally(() => {
                            stopLoading();
                        });
                }
            }
        }
    };

    return (
        <>
            <div className="row">
                <div className="col-12">
                    <label>Paiement par virement: </label>
                </div>
            </div>

            <div class="row">
                <div class="col-md-4">
                    <label>Montant : </label>
                    <input
                        type="number"
                        min="0"
                        step="0.1"
                        class="form-control"
                        max={localStorage.getItem("restToPay")}
                        name="amount"
                        value={amount}
                        onChange={changeAmount}
                    />
                </div>
                <div class="col-md-4">
                    <label>Num.virement: </label>
                    <input
                        value={codeVirement}
                        onChange={changeCodeVirement}
                        class="form-control"
                        placeholder="Code du virement"
                        type="number"
                    />
                </div>

                <div class="col-md-4">
                    <label>Date de l'échéance </label>
                    <br />
                    <TextField
                        style={{ width: "100%" }}
                        className="col-sm-12"
                        variant="outlined"
                        value={datePayement}
                        onChange={changeDatePayement}
                        id="datetime-local"
                        type="datetime-local"
                        defaultValue="date"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        size="small"
                    />
                </div>

                <div class="col-md-12">
                    <div className="row">
                        <div className="col-sm-12">
                            <div class="form-group">
                                <label for="exampleInputFile">Ajouter Virement </label>
                                <div class="input-group">
                                    <div class="custom-file">
                                        <input
                                            accept="application/pdf, .jpg, .jpeg, .png"
                                            type="file"
                                            className="custom-file-input"
                                            id="exampleInputFile"
                                            onChange={onUploadFileHandler}
                                        />
                                        <label class="custom-file-label" for="exampleInputFile">
                                            {fileName}{" "}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-12">
                    <label>Compte bancaire </label>
                    <ListBanquesToPayement type={1} />
                </div>
                <br />
                <div class="col-12">
                    <button
                        type="submit"
                        onClick={payerBill}
                        className="btn btn-dark float-right"
                    >
                        Payer
                    </button>
                </div>
            </div>
            <Snackbar
                open={openErrorAlert}
                autoHideDuration={2000}
                onClose={handleEroorClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            >
                <Alert variant="filled" onClose={handleEroorClose} severity="error">
                    {errorAlertText}
                </Alert>
            </Snackbar>
            <Snackbar
                open={openInfoAlert}
                autoHideDuration={4000}
                onClose={handleInfoClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            >
                <Alert onClose={handleInfoClose} severity="info">
                    {infoAlertText}
                </Alert>
            </Snackbar>
        </>
    );





}
export default withLoader(PayementAvanceBillVirementFN)